import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router";
import { motion } from "framer-motion";
import "./SheSaidYes2026.css";

const hearts = Array.from({ length: 18 }, (_, i) => ({
  id: i,
  left: `${Math.random() * 100}%`,
  top: `${Math.random() * 100}%`,
  delay: Math.random() * 4,
  size: 0.8 + Math.random() * 1.2,
}));

const SheSaidYes2026 = () => {
  const navigate = useNavigate();

  // Load Picflow embed script
  useEffect(() => {
    if (!window.picflow) {
      window.picflow = true;
      const s = document.createElement("script");
      s.src = "https://picflow.com/embed/main.js";
      s.type = "module";
      s.defer = true;
      document.head.appendChild(s);
    }
  }, []);

  // Play invisibleString.mp3
  const audioRef = useRef(null);
  useEffect(() => {
    const audio = new Audio("/audio/invisibleString.mp3");
    audioRef.current = audio;
    audio.play().catch((err) => console.error("Audio playback failed:", err));

    return () => {
      audio.pause();
      audio.currentTime = 0;
    };
  }, []);

  return (
    <div className="yes26-container yes26-with-gallery">
      {/* Floating hearts background */}
      <div className="yes26-hearts">
        {hearts.map((h) => (
          <span
            key={h.id}
            className="yes26-heart"
            style={{
              left: h.left,
              top: h.top,
              animationDelay: `${h.delay}s`,
              fontSize: `${h.size}rem`,
            }}
          >
            💗
          </span>
        ))}
      </div>

      {/* White overlay intro – same timing as 2025 */}
      <motion.div
        className="yes26-overlay"
        initial={{ opacity: 1 }}
        animate={{ opacity: 0 }}
        transition={{ delay: 3, duration: 2 }}
      >
        <h1>I Love You!</h1>
        <p>have a scroll through some of our memories</p>
      </motion.div>

      {/* Gallery slides up like 2025 */}
      <motion.div
        className="yes26-gallery-wrap"
        initial={{ opacity: 0, y: "100vh" }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 4, duration: 3 }}
      >
        <picflow-gallery
          id="gal_hGicpHd4E7RdGAd8"
          tenant="tnt_KaEAbDNoYLLiE0u6"
          lightbox="#000000E6"
          no-padding="true"
          no-background="true"
          show-cover="true"
        />
        <motion.button
          className="yes26-back"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 7 }}
          onClick={() => navigate("/2026")}
        >
          ← back to letter
        </motion.button>
      </motion.div>
    </div>
  );
};

export default SheSaidYes2026;
